import * as React from 'react'

import { Box, Icon, Text, colors } from '@factorialco/deprecated-design-system'
import { Node, TooltipProps } from '@nivo/scatterplot'

import i18n from 'modules/core/lib/i18n'

import { formatSalaryAmount } from 'modules/job_catalog/lib/salaryUtils'

import { SalaryDatum } from '../lib'

type CustomNode = Node & { data: Node['data'] & SalaryDatum }

const Tooltip: React.FC<TooltipProps> = ({ node }) => {
  const customNode = node as CustomNode
  const {
    x: jobCatalogLevel,
    targetMin,
    targetMax,
    currency,
    y: contractSalary,
    count,
    country,
  } = customNode.data
  const formattedMin = formatSalaryAmount(targetMin, country, currency)
  const formattedMax = formatSalaryAmount(targetMax, country, currency)
  const formattedContractSalary = formatSalaryAmount(Number(contractSalary), country, currency)
  return (
    <Box
      borderRadius={{
        all: 'abs008',
      }}
      style={{
        background: colors.darker800,
      }}
      padding="s12"
      justifyContent="flexStart"
      gap="s16"
      width="s200"
    >
      <Box gap="s4">
        <Text.Normal color="grey100" weight="medium">
          {jobCatalogLevel as string}
        </Text.Normal>
        <Text.Normal color="grey100">
          {count} {i18n.t('common.employees')}
        </Text.Normal>
      </Box>
      <Box gap="s4">
        <Box flexDirection="row">
          <Icon.Medium icon="circle" color="viridian800" />
          <Text.Normal color="grey100">
            {i18n.t('job_catalog.salary_insights_tooltip.target')}
          </Text.Normal>
        </Box>
        <Text.Normal color="grey100">
          {targetMin === targetMax ? `${formattedMin}` : `${formattedMin} - ${formattedMax}`}
        </Text.Normal>
      </Box>
      <Box gap="s4">
        <Box flexDirection="row">
          <Icon.Medium icon="circle" color="purple1000" />
          <Text.Normal color="grey100">
            {i18n.t('job_catalog.salary_insights_tooltip.current')}
          </Text.Normal>
        </Box>
        <Text.Normal color="grey100">{formattedContractSalary}</Text.Normal>
      </Box>
    </Box>
  )
}

export default Tooltip
